import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import { generateVideoUrl } from '../utils/generate-video-url';
import template from './support-video-thumbnails.component.html';
var SupportVideoThumbnailsComponent = (function () {
    function SupportVideoThumbnailsComponent() {
    }
    SupportVideoThumbnailsComponent.prototype.getVideoUrl = function (video) {
        return generateVideoUrl(this.group, video === null || video === void 0 ? void 0 : video.id);
    };
    SupportVideoThumbnailsComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], SupportVideoThumbnailsComponent.prototype, "group", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], SupportVideoThumbnailsComponent.prototype, "hideDescription", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], SupportVideoThumbnailsComponent.prototype, "videos", void 0);
    SupportVideoThumbnailsComponent = __decorate([
        Component({
            selector: 'supportVideoThumbnails',
            template: template,
        })
    ], SupportVideoThumbnailsComponent);
    return SupportVideoThumbnailsComponent;
}());
export { SupportVideoThumbnailsComponent };
